import {
  Component,
  DOCUMENT,
  Inject,
  inject,
  Input,
  signal,
} from '@angular/core';
import { Image } from '../../components/shared/image/image';
import { Button } from '../../components/shared/button/button';
import { environment } from '@env/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { Dialog } from '@app/components/shared/dialog/dialog';

@Component({
  selector: 'app-login',
  imports: [Image, Button, Dialog],
  templateUrl: './login.html',
  styleUrl: './login.css',
})
export class LoginPage {
  private readonly router = inject(Router);
  showModal = signal(false);
  reason: string | null = null;
  constructor(
    private route: ActivatedRoute,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  handleClick() {
    this.redirectToSSO();
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (!!params['reason']) {
        if (params['reason'] === 'unauthorized') {
          this.reason =
            'No tienes permiso para acceder a la página solicitada.';
        }
        if (params['reason'] === 'unauthenticated') {
          this.reason =
            'Para continuar, necesitamos que inicies sesión para acceder a la página que deseas';
        }
        if (params['reason'] === 'logout') {
          this.reason = 'Has cerrado sesión correctamente.';
        }
        if (params['reason'] === 'session_expired') {
          this.reason =
            'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';
        }
        this.openModal();
      }
    });
  }

  openModal() {
    this.showModal.set(true);
  }

  closeModal() {
    this.showModal.set(false);
  }

  redirectToSSO() {
    this.document.location.href = environment.ssoUrl;
  }
}
